import { Manager } from "@twilio/flex-ui";

/*
 * Resolves a worker's SMID from their workerSid by calling the
 * existing "get-worker-name" endpoint, which returns the
 * Twilio worker record.
 */
function fetchWorkerProfileInfo(serviceBaseUrl, workerSid) {
    return new Promise((resolve) => {
        if (!serviceBaseUrl || !workerSid) {
            resolve({ smid: null });
            return;
        }

        fetch(serviceBaseUrl + "get-worker-name",
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                method: "POST",
                body: new URLSearchParams({
                    Token: Manager.getInstance().user.token,
                    WorkerSid: workerSid
                })
            })
            .then(response => response.json())
            .then(json => {
                let smid = null;

                if (json != null && json.length > 0) {
                    smid = json[0].friendlyName ?? null;
                }

                resolve({ smid: smid });
            })
            .catch((err) => {
                console.log("FETCH ERROR: ", err);
                resolve({ smid: null });
            });
    });
}

export default fetchWorkerProfileInfo;
